/* <gift-card-add> — adds the complimentary $25 gift card to the cart and,
   depending on data-after, opens the theme cart drawer or reloads the page.
   Used by the gift-card upsell prompts (product page, cart drawer, cart page,
   flowers collection). Self-contained; does not depend on product-form.js. */
(function () {
  if (customElements.get('gift-card-add')) return;

  var DRAWER_SECTIONS = [
    'cart-notification-product',
    'cart-notification-subtotal',
    'cart-notification-count',
    'cart-notification-discount'
  ];

  customElements.define('gift-card-add', class extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-gcu-add]');
      if (!this.btn || this._bound) return;
      this._bound = true;
      this._onClick = this.onClick.bind(this);
      this.btn.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.btn && this._onClick) this.btn.removeEventListener('click', this._onClick);
    }

    onClick(evt) {
      evt.preventDefault();
      if (this.loading) return;
      this.loading = true;

      var btn = this.btn;
      var variantId = this.dataset.variantId;
      var addUrl = this.dataset.addUrl || '/cart/add';
      var cartUrl = this.dataset.cartUrl || '/cart';
      var after = this.dataset.after || 'drawer';
      var addedLabel = this.dataset.addedLabel || 'Added';
      var original = btn.textContent;

      btn.setAttribute('disabled', 'disabled');

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', 1);
      if (after === 'drawer') {
        body.append('sections', DRAWER_SECTIONS.join(','));
        body.append('sections_url', window.location.pathname);
      }

      var self = this;
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: body
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart failed');
          return res.json();
        })
        .then(function (state) {
          btn.textContent = addedLabel;
          btn.classList.add('is-added');

          if (after === 'reload') {
            setTimeout(function () { window.location.reload(); }, 450);
            return;
          }

          var cartNotification = document.querySelector('cart-notification');
          if (cartNotification && typeof cartNotification.renderContents === 'function' && state && state.sections) {
            cartNotification.renderContents(state);
          } else {
            // No drawer available — fall back to the cart page.
            setTimeout(function () { window.location.href = cartUrl; }, 400);
            return;
          }

          // The gift card is now in the cart: remove every upsell prompt on the page.
          document.querySelectorAll('.gcu-prompt').forEach(function (el) { el.remove(); });

          // Keep the header/drawer counts in sync.
          fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (!cart || typeof cart.item_count === 'undefined') return;
              document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-drawer-count, [data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count } }));
            })
            .catch(function () {});
        })
        .catch(function () {
          self.loading = false;
          btn.removeAttribute('disabled');
          btn.classList.remove('is-added');
          btn.textContent = original;
        });
    }
  });
})();
